export default __webpack_public_path__ + "static/media/gallery_16.9fb6cc27.jpg";